import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-white py-24 px-6 text-center" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-brand-black mb-6" data-id="element-95">
          Hoy podés elegir.
        </h2>
        <p className="text-2xl md:text-3xl font-medium text-brand-sage mb-8" data-id="element-96">
          Seguir improvisando… o tener claridad.
        </p>

        <div className="bg-brand-red/10 border border-brand-red/20 rounded-xl p-4 max-w-md mx-auto mb-8" data-id="element-97">
          <p className="text-brand-red font-bold text-lg" data-id="element-98">
            ⚠️ Última oportunidad para acceder con 50% OFF
          </p>
          <p className="text-brand-red/80 text-sm mt-1" data-id="element-99">
            El precio de $19.990 puede subir en cualquier momento.
          </p>
        </div>

        <CTAButton text="QUIERO DEJAR DE IMPROVISAR" className="md:px-12 md:py-5 text-xl" data-id="element-100" />
        <p className="text-sm text-brand-charcoal/60 font-medium mt-4" data-id="element-101">
          Garantía de 30 días • Pago 100% seguro
        </p>
      </div>
    </section>;
}